"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var domElementPropType = function domElementPropType(props, propName, componentName) {
  var value = props[propName];
  if (value == null || (0, _typeof2.default)(value) === 'object' && value.nodeType === 1) return null;
  return new Error(componentName + ": Invalid " + propName + " value. Expected a DOM element.");
};

var _default = (0, _createChainablePropType.default)(domElementPropType, 'DOM element');

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/propTypes/domElement.js
// module id = 162
// module chunks = 209 210 211 212